import { atom, useAtom } from "jotai";
import { State } from "./State";
import { postBase } from "./BaseApi";

export type ExternalSimulationPostParam = {
  simulationId: string;
};

const uri = "api/external-simulation";

export const postExternalSimulationAtom = atom<State<null> | null>(null);
export const postExternalSimulation = () => {
  return postBase<null, ExternalSimulationPostParam>(
    uri,
    postExternalSimulationAtom
  );
};
